// extracted by mini-css-extract-plugin
export default {"imgWidths":"guide_imgWidths__L6Zs7","container":"guide_container__m9UW1","toggles":"guide_toggles__kd0sH","pToggles":"guide_pToggles__8Hep5"};